import { defineAsyncComponent } from 'vue'
import type { Component } from 'vue'
import type { ShowOptions } from '@/components/appDialog/types'
import i18n from '@/i18n'
import TeamShare from './teamShareDialog.vue'
const JoinTeam = defineAsyncComponent(() => import('./JoinTeam.vue'))
const ForbiddenJoin = defineAsyncComponent(() => import('./ForbiddenJoin.vue'))
const QRCode = defineAsyncComponent(() => import('./qrCodeDialog.vue'))
const ExitTeam = defineAsyncComponent(() => import('./exitTeamDialog.vue'))
const ConfigForm = defineAsyncComponent(
  () => import('./createGroup/configForm.vue')
)
const SelectAvatar = defineAsyncComponent(
  () => import('./selectAvatarDialog.vue')
)
const MemberSelector = defineAsyncComponent(
  () => import('./memberSelectorDialog.vue')
)
const inputConfirm = defineAsyncComponent(() => import('./inputConfirm.vue'))

type keys =
  | 'title'
  | 'showCloseIcon'
  | 'size'
  | 'footer'
  | 'modalProps'
  | 'componentProps'
  | 'hideMask'
  | 'maskClosable'
  | 'modalStyle'
  | 'showBackIcon'

interface DialogComponent extends Pick<ShowOptions, keys> {
  body: Component
}
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return i18n.global.t(`components.dialog.${key}`, ...params)
}

export const dialogComponents: Record<string, DialogComponent> = {
  // 外部人员禁止加入团队弹窗
  ForbiddenJoin: {
    title: $tt('forbiddenJoin.title'),
    body: ForbiddenJoin,
    modalProps: {
      style: {
        width: '440px'
      }
    },
    footer: false
  },
  // 加入团队弹窗
  JoinTeam: {
    title: $tt('joinTeam.title'),
    body: JoinTeam,
    modalProps: {
      style: {
        width: '440px',
        padding: '24px'
      }
    }
  },
  TeamShare: {
    title: $tt('teamShare.title'),
    body: TeamShare,
    footer: false
  },
  QRCode: {
    title: $tt('qrCode.title'),
    body: QRCode,
    footer: false,
    showBackIcon: true,
    showCloseIcon: false,
    modalProps: {
      style: {
        width: '540px',
        height: '473px'
      }
    }
  },
  ExitTeam: {
    title: '退出协作空间',
    body: ExitTeam,
    footer: false
  },
  ConfigForm: {
    title: '123',
    body: ConfigForm,
    footer: false
  },
  SelectAvatar: {
    size: 'auto',
    body: SelectAvatar,
    footer: false,
    modalStyle: {
      padding: '0px'
    },
    showCloseIcon: false
  },
  MemberSelector: {
    modalProps: {
      style: {
        width: '600px'
      }
    },
    footer: false,
    body: MemberSelector,
    showCloseIcon: false
  },
  inputConfirm: {
    modalProps: {
      style: {
        width: '480px'
      }
    },
    footer: false,
    body: inputConfirm
  }
}
